<label *ngIf="htmlStr; else labelContent" [class]="class" [for]="for" [innerHTML]="htmlStr + (required ? requiredSuffix : '')"></label>
<ng-template #labelContent>
  <label [class]="class" [for]="for">
    <ng-content></ng-content>
    <ng-container *ngIf="required">{{ requiredSuffix }}</ng-container>
  </label>
</ng-template>
